import { Component, effect, Input, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Constants } from "../../../constants";
import { IArcusApplication, IArcusApplicationMenu } from "../../interfaces";
import DataService from "../services/data.service";
import ExceptionService from "../services/exception.service";
import { ArcusLayoutService } from "../services/arcus-layout.service";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatNavList, MatListItem, MatListItemIcon, MatListItemTitle } from "@angular/material/list";
import { UserPreferenceService } from "../../SettingsV2/services/user-preference.service";

@Component({
    selector: "navigation",
    templateUrl: "./navigation.component.html",
    styleUrls: ["./navigation.component.scss"],
    imports: [MatToolbar, MatIconButton, MatIcon, MatNavList, MatListItem, MatListItemIcon, MatListItemTitle],
})
export class NavigationComponent implements OnInit, OnDestroy {
    appMenu: boolean;
    apps: IArcusApplication[] = [];
    menuItems: IArcusApplicationMenu[] = [];
    filteredMenuItems: IArcusApplicationMenu[] = [];
    subs: Subscription[] = [];

    get appName(): string {
        return this.locationDisplay[0]
            ? this.locationDisplay[0][0].toUpperCase() + this.locationDisplay[0].substring(1)
            : null;
    }

    get currentAppId(): number {
        return this.appName && this.apps.length > 0
            ? this.apps.find((x) => x.Name.replace(" ", "").toUpperCase() === this.appName.toUpperCase())?.ID
            : 0;
    }

    get locationDisplay(): string[] {
        let path = window.location.pathname
            .substring(window.location.pathname.indexOf(Constants.baseURL) + 1)
            .split("/")
            .filter((x) => !Number(x) && Boolean(x))
            .map((x) => x.replace(/([A-Z])/g, " $1").trim());
        return path;
    }

    constructor(
        public layoutService: ArcusLayoutService,
        private dataService: DataService,
        private exceptionService: ExceptionService,
        public router: Router,
        private userPreferenceService: UserPreferenceService
    ) {
        effect(() => {
            if (this.layoutService.isNavigationOpen() && this.apps) {
                this.setMenu(this.currentAppId);
            }
        });
    }

    ngOnInit(): void {
        Promise.all([this.getApplications(), this.getApplicationMenus()])
            .then((results) => {
                if (results[0]) {
                    this.apps = results[0];
                    this.apps.forEach((x) => (x.Url = x.Url.replace("~", "").toLowerCase()));
                }

                if (results[1]) {
                    this.menuItems = results[1];
                    this.menuItems.forEach((x) => (x.Url = x.Url.replace("~", "").toLowerCase()));
                }
            })
            .catch((error) => this.exceptionService.handleException(error))
            .finally(() => {
                this.setMenu(this.currentAppId);
            });

        this.router.events.forEach((event) => {
            if (event instanceof NavigationStart) {
                if (event.url.includes("dispatch/track/") && this.userPreferenceService.preferences().UniTrack)
                    this.router.navigateByUrl(event.url.replace("track", "trackBeta"));
            }
            if (event instanceof NavigationEnd) {
                this.layoutService.closeNavigation();
                this.setMenu(this.currentAppId);
            }
        });
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => sub.unsubscribe());
    }

    getApplications(): Promise<IArcusApplication[]> {
        return this.dataService.getApi<IArcusApplication[]>("ArcusApplication");
    }

    getApplicationMenus(): Promise<IArcusApplicationMenu[]> {
        return this.dataService.getApi<IArcusApplicationMenu[]>(`ArcusApplicationMenu`);
    }

    setMenu(id: Number) {
        this.filteredMenuItems = this.menuItems?.filter((x) => x.ArcusApplicationID === id);
        this.appMenu = Boolean(this.filteredMenuItems?.length);
    }

    onMenuItemClick(item: IArcusApplicationMenu) {
        this.layoutService.closeNavigation();
        this.router.navigate([item.Url]);
    }

    onHomeClick(): void {
        this.layoutService.closeNavigation();
        this.router.navigate(["/"]);
    }

    onApplicationClick(app: IArcusApplication) {
        app.HasMenu ? this.setMenu(app.ID) : (this.layoutService.closeNavigation(), this.router.navigate([app.Url]));
    }

    locationChange() {
        this.setMenu(this.currentAppId);
    }
}

